/**
 * Hill Flights Shop — minimal storefront JS.
 * Variant price/label swap and pre-order state on the product page;
 * no framework, no build step.
 */
(function () {
  'use strict';

  var variantSelects = document.querySelectorAll('[data-variant-select]');

  variantSelects.forEach(function (select) {
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var form = select.closest('form');

      var price = option.getAttribute('data-price');
      var priceEl = document.querySelector('[data-price]');
      if (price && priceEl) {
        priceEl.textContent = price;
      }

      var isPreorder = option.getAttribute('data-preorder') === 'true';
      var isSoldOut = option.disabled;

      var note = form ? form.querySelector('[data-preorder-note]') : null;
      if (note) {
        note.hidden = !isPreorder;
      }

      var submit = form ? form.querySelector('[data-submit-button]') : null;
      if (submit) {
        submit.disabled = isSoldOut;
        if (isSoldOut) {
          submit.textContent = select.getAttribute('data-label-sold-out');
        } else if (isPreorder) {
          submit.textContent = select.getAttribute('data-label-preorder');
        } else {
          submit.textContent = select.getAttribute('data-label-add');
        }
      }
    });
  });
})();
